module.exports = __webpack_public_path__ + "static/scale-model-of-jack-rabbit-in-odessa-texas-d392ca28d50b8e38c255750d0461bf5f.png";